import React, { Component } from 'react';
import {
    Popover as BSPopover,
    PopoverHeader,
    PopoverBody
} from 'reactstrap';
import { Input } from '../Common';
import { apiQuickUpdateFactoryEvaluation } from '../../api/factory-evaluation'

class UpdateContactPopup extends Component {
    state = {
        popoverOpen: false,
        id: this.props.id,
        value: this.props.value,
        error: false,
    }

    toggle = async () => {
        this.setState({
            popoverOpen: !this.state.popoverOpen,
            value: this.props.value,
            error: false,
        });
    }

    handleChange(value) {
        this.setState({ value: value});
    }

    onConfirm = async () => {
        if (this.state.value !== '') {
          await apiQuickUpdateFactoryEvaluation(this.props.evalId, { vendor_co_certificate_recipient: this.state.value })
          this.toggle();
          this.props.refresh();
        } else {
          this.setState({ error: true })
        }
    }

    onCancel = () => {
        this.setState({ popoverOpen: false })
    }

    render() {
        const { id, t } = this.props;
        return (
            <React.Fragment>
                <span onClick={typeof this.props.children === 'object' ? this.toggle : undefined}>
                    {this.props.children}
                </span>
            {typeof this.props.children === 'object' &&
                <BSPopover className="edit-content-container" placement={'bottom'} isOpen={this.state.popoverOpen} target={'contactPopover-' + id} toggle={this.toggle}>
                    <PopoverHeader></PopoverHeader>
                    <PopoverBody className={'el-table-edit'} style={{padding: '20px', maxWidth: '250px'}}>
                        <Input
                          type="text"
                          value={this.state.value}
                          onChange={(value) => this.handleChange(value)}
                        />
                        <div className="el-table-edit__bottom" key="bottom">
                            <button onClick={this.onCancel}>
	                            {t('global.cancel')}
                            </button>
                            <button onClick={this.onConfirm}>
                              {t('global.submit')}
                            </button>
                        </div>
                    </PopoverBody>
                </BSPopover>}
            </React.Fragment>
        )
    }
}

export default UpdateContactPopup;
